"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformChildSeatTypeToString = transformChildSeatTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformChildSeatTypeToString(childSeatType) {
    switch (childSeatType) {
        case legacy_enums_1.ChildSeatType.Booster:
            return "booster";
        case legacy_enums_1.ChildSeatType.BoosterSeat:
            return "booster seat";
        case legacy_enums_1.ChildSeatType.ForwardFacing:
            return "forward facing";
        case legacy_enums_1.ChildSeatType.RearFacing:
            return "rear facing";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformChildSeatTypeToString.js.map